import type { FC } from 'react';
import IconMdi from '@components/IconMdi';
import { Button } from '@components/ui/button';
import { mdiRefresh } from '@mdi/js';

interface VersionMismatchToast {
  running: string;
  latest: string;
}

export const VERSION_MISMATCH_TOAST_ID = 'version-mismatch';

export const VersionMismatchToast: FC<VersionMismatchToast> = ({ running, latest }) => (
  <div className="max-w-[264px]">
    <p className="text-info-900 pb-2 text-sm font-semibold">New version available</p>
    <p className="text-info-500 mt-1 truncate text-sm" title={running}>
      Running version: {running}
    </p>
    <p className="text-info-500 truncate text-sm" title={latest}>
      Latest version: {latest}
    </p>
    <Button variant="outline" size="sm" onClick={() => window.location.reload()} className="mt-3 w-full bg-white!">
      <IconMdi path={mdiRefresh} size={0.75} centerVertical={false} />
      Refresh now
    </Button>
  </div>
);
